export const SERVICE = {
  HOTEL_SERVICE_ID: 1,
  TAXI_SERVICE_ID: 4,
  MEAL_PLAN_SERVICE_ID: 23
}
